import { Button } from '@/shared/ui/button'
import { VLayout } from '@/shared/ui/layouts/flex'
import { Typography } from '@/shared/ui/typography'

import type { MouseEvent } from 'react'
import { FileEarmarkLock2 } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

export default function Component() {
  const { t } = useTranslation()
  const location = useLocation()

  // Already on the home page, a plain link would do nothing: reloading fetches the user info
  // again, the only way to pick up permissions granted since.
  const handleReturnHome = (event: MouseEvent) => {
    if (location.pathname === '/') {
      event.preventDefault()
      window.location.reload()
    }
  }

  return (
    // This `main` sits inside the `main` of the Layout: a duplicate landmark kept for migration
    // parity with the legacy screen (raised to the PO).
    <main className="mt-36 h-full w-full pb-52">
      <VLayout items="center" justify="center" gap="6">
        {/* No Design System equivalent for the round icon badge: kept as plain utilities. */}
        <div className="bg-neutral/10 flex h-20 w-20 items-center justify-center rounded-full">
          <FileEarmarkLock2 size={38} aria-hidden="true" />
        </div>

        <div className="max-w-md text-center">
          <Typography type="heading" as="h1" variant="h5-bold">
            {t('common.noAccess.text1')}
          </Typography>
        </div>

        <div className="max-w-md text-center">
          {/*
           * `propagate={false}`: the default propagation forces every child to inherit the
           * paragraph colour and weight, which would strip the link of its own style.
           */}
          <Typography type="paragraph" as="p" color="secondary" propagate={false}>
            {t('common.noAccess.text2')}
            <a href="mailto:irprojectteam@ardian.com" className="link link-primary font-medium">
              irprojectteam@ardian.com
            </a>
          </Typography>
        </div>

        <Button
          intent="secondary"
          variant="outline"
          to="/"
          onClick={handleReturnHome}
          className="mt-5"
        >
          {t('common.returnToHome')}
        </Button>
      </VLayout>
    </main>
  )
}
